<template>
  <div class="branding-filter__content">
    <div v-for="(elem, i) in dropDowns" :key="i" class="branding-filter__cell">
      <template v-if="elem.items">
        <multi-select
          v-model="payload[elem.id]"
          class="branding-filter__input"
          display-key="text"
          :options="elem.items"
          :title="elem.title"
          @keyup.enter="submit"
        />
      </template>
    </div>
    <div class="branding-filter__cell">
      <radio-group
        v-if="radioData.items"
        v-model="payload[radioData.id]"
        :class="{ removeMargin: !isMobile }"
        :items="radioData.items"
        required
        :horizontal="isMobile"
        @keyup.enter="submit"
      />
      <div class="branding-filter__button">
        <sanitas-button
          class="removeMargin"
          primary
          full-width-in-xs
          @click="submit"
        >
          {{ $t('button-submit') }}
        </sanitas-button>
      </div>
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import MultiSelect from './MultiSelect'

export default {
  name: 'SanitasBrandingFilterShort',
  components: {
    RadioGroup: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/RadioGroup'
      )
    },
    SanitasButton: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/SanitasButton'
      )
    },
    MultiSelect,
  },
  props: {
    dropDowns: {
      type: Array,
      default: () => [],
    },
    radioData: {
      type: Object,
      default: () => ({}),
    },
    defaultValues: {
      type: Object,
      default: () => ({}),
    },
    fatpagepath: {
      type: String,
      default: '/de/ueber-sanitas/arbeiten-bei-sanitas/offene-stellen.html',
    },
  },

  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },

  data: () => ({
    payload: {},
  }),
  computed: {
    isMobile() {
      return !this.$mq['md!']
    },
  },
  watch: {
    defaultValues: {
      handler(values) {
        this.payload = values
      },
      immediate: true,
    },
  },
  methods: {
    submit() {
      const params = Object.keys(this.payload)
        .map(key => {
          if (Array.isArray(this.payload[key])) {
            return this.payload[key]
              .map(el => key + '=' + encodeURIComponent(el))
              .join('&')
          }
          return key + '=' + encodeURIComponent(this.payload[key])
        })
        .join('&')
      window.location.href = this.fatpagepath + '#' + params
    },
  },
}
</script>

<style lang="postcss"></style>
